// ======================header-desktop start===================
document.addEventListener("DOMContentLoaded", function () {
  // Handle COLLECTIONS menu
  const collectionsMenuItem = document.querySelector(
    'li[data-item-title="COLLECTIONS"]'
  );
  if (collectionsMenuItem) {
    const pcMenu = collectionsMenuItem.querySelector(".pc-menu");
    if (pcMenu) {
      collectionsMenuItem.addEventListener("mouseenter", () => {
        pcMenu.style.display = "block";
      });

      collectionsMenuItem.addEventListener("mouseleave", () => {
        pcMenu.style.display = "none";
      });
    }
  }

  // Handle GIFT GUIDE menu
  const giftGuideMenuItem = document.querySelector(
    'li[data-item-title="GIFT GUIDE"]'
  );
  if (giftGuideMenuItem) {
    const pcMenuGift = document.querySelector(".pc-menu-giftrr");
    const subMegaGi = document.getElementById("sub_mega_gi");

    if (pcMenuGift && subMegaGi) {
      // Append sub menu if not already appended
      if (!giftGuideMenuItem.contains(subMegaGi)) {
        giftGuideMenuItem.appendChild(subMegaGi);
      }

      giftGuideMenuItem.addEventListener("mouseenter", () => {
        pcMenuGift.style.display = "block";
      });

      giftGuideMenuItem.addEventListener("mouseleave", () => {
        pcMenuGift.style.display = "none";
      });
    }
  }

  // Handle PRODUCT CATEGORY menu visibility
  const productCategoryMenuItem = document.querySelector(
    'li[data-item-title="PRODUCT CATEGORY"]'
  );
  if (productCategoryMenuItem) {
    function updateMenuItemVisibility() {
      if (window.innerWidth >= 768) {
        productCategoryMenuItem.classList.add("hide-desktop");
        productCategoryMenuItem.classList.remove("hide-mobile");
      } else {
        productCategoryMenuItem.classList.add("hide-mobile");
        productCategoryMenuItem.classList.remove("hide-desktop");
      }
    }

    // Initial visibility check
    updateMenuItemVisibility();

    // Update visibility on window resize
    let resizeTimeout;
    window.addEventListener("resize", () => {
      // Debounce resize event
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateMenuItemVisibility, 250);
    });
  }
});

// Color effect functions for menu items
function gold_color_effect1() {
  resetActiveItems();
  document.querySelector(".ex-online .tablinks").classList.add("pcc-active");
  showMenuContent("HeaderMenu-collections-online");
}

function gold_color_effect2() {
  resetActiveItems();
  document.querySelector(".bridal-sub .tablinks").classList.add("pcc-active");
  showMenuContent("HeaderMenu-collections-bridal");
}

// Helper functions
function resetActiveItems() {
  document.querySelectorAll(".pcc-active").forEach((item) => {
    item.classList.remove("pcc-active");
  });
}

function showMenuContent(id) {
  // Hide all menu contents
  document.querySelectorAll(".column.subcat").forEach((content) => {
    content.style.display = "none";
  });

  // Show selected content
  const selectedContent = document.getElementById(id);
  if (selectedContent) {
    selectedContent.style.display = "block";
  }
}

// Gift menu functions
function showMom() {
  resetGiftActiveItems();
  document.querySelector(".mom-dsk").classList.add("pcc-active-gift");
  showGiftMenuContent("HeaderMenu-collections-online-gift");
}

function showDad() {
  resetGiftActiveItems();
  document.querySelector(".dad-dsk").classList.add("pcc-active-gift");
  showGiftMenuContent("HeaderMenu-collections-bridal-gift");
}

function resetGiftActiveItems() {
  document.querySelectorAll(".pcc-active-gift").forEach((item) => {
    item.classList.remove("pcc-active-gift");
  });
}

function showGiftMenuContent(id) {
  document
    .querySelectorAll(".pc-contents .column.subcat")
    .forEach((content) => {
      content.style.display = "none";
    });

  const selectedContent = document.getElementById(id);
  if (selectedContent) {
    selectedContent.style.display = "block";
  }
}

// ======================header-desktop end===================
// ======================header-mobile start===================

document.addEventListener("DOMContentLoaded", function () {
  child_anchor_ele = document.getElementsByClassName("element_op_clo");

  const secondChild1 = document.querySelector(
    "ul.menu_links > li:nth-child(2)"
  );
  const thirdChild1 = document.querySelector("ul.menu_links > li:nth-child(3)");
  const fourthChild1 = document.querySelector(
    "ul.menu_links > li:nth-child(4)"
  );
  const fifthChild = document.querySelector("ul.menu_links > li:nth-child(5)");
  const seventhChild = document.querySelector(
    "ul.menu_links > li:nth-child(8)"
  );

  const collectionElement = document.getElementById("pc-menu--mob-id");
  const productElement = document.getElementById("pc-menu--mob-id-products");
  const giftElement = document.getElementById("pc-menu--mob-id-gift-guide");
  const promotionsElement = document.getElementById(
    "pc-menu--mob-id-promotions"
  );
  const pccElement = document.getElementById("pc-menu--mob-id-legacy");

  const collectionElementopen = document.getElementById("arrow_mob1_open");
  const collectionElementoclose = document.getElementById("arrow_mob1_close");
  const productElementopen = document.getElementById("arrow_mob2_open");
  const productElementclose = document.getElementById("arrow_mob2_close");
  const promotionsElementopen = document.getElementById("arrow_mob3_open");
  const promotionsElementclose = document.getElementById("arrow_mob3_close");
  const giftElementopen = document.getElementById("arrow_mob4_open");
  const giftElementclose = document.getElementById("arrow_mob4_close");

  productElement.style.display = "block";
  productElementopen.style.display = "block";
  productElementclose.style.display = "none";
  child_anchor_ele[0].style.color = "#F00";

  if (secondChild1) secondChild1.appendChild(productElement);
  if (thirdChild1) thirdChild1.appendChild(collectionElement);
  if (fourthChild1) fourthChild1.appendChild(promotionsElement);
  if (fifthChild) fifthChild.appendChild(giftElement);
  if (seventhChild) seventhChild.appendChild(pccElement);

  if (secondChild1) {
    secondChild1.addEventListener("click", function () {
      collectionElement.style.display = "none";
      productElement.style.display = "block";
      giftElement.style.display = "none";
      promotionsElement.style.display = "none";
      pccElement.style.display = "none";

      collectionElementopen.style.display = "none";
      collectionElementoclose.style.display = "block";
      productElementopen.style.display = "block";
      productElementclose.style.display = "none";
      promotionsElementopen.style.display = "none";
      promotionsElementclose.style.display = "block";
      giftElementopen.style.display = "none";
      giftElementclose.style.display = "block";

      child_anchor_ele[0].style.color = "#F00";
      child_anchor_ele[1].style.color = "";
      child_anchor_ele[2].style.color = "";
      child_anchor_ele[3].style.color = "";
      child_anchor_ele[4].style.color = "";
    });
  }

  if (thirdChild1) {
    thirdChild1.addEventListener("click", function () {
      collectionElement.style.display = "block";
      productElement.style.display = "none";
      giftElement.style.display = "none";
      promotionsElement.style.display = "none";
      pccElement.style.display = "none";

      collectionElementopen.style.display = "block";
      collectionElementoclose.style.display = "none";
      productElementopen.style.display = "none";
      productElementclose.style.display = "block";
      promotionsElementopen.style.display = "none";
      promotionsElementclose.style.display = "block";
      giftElementopen.style.display = "none";
      giftElementclose.style.display = "block";

      child_anchor_ele[0].style.color = "";
      child_anchor_ele[1].style.color = "#F00";
      child_anchor_ele[2].style.color = "";
      child_anchor_ele[3].style.color = "";
      child_anchor_ele[4].style.color = "";
    });
  }

  if (fourthChild1) {
    fourthChild1.addEventListener("click", function () {
      collectionElement.style.display = "none";
      productElement.style.display = "none";
      giftElement.style.display = "none";
      promotionsElement.style.display = "block";
      pccElement.style.display = "none";

      collectionElementopen.style.display = "none";
      collectionElementoclose.style.display = "block";
      productElementopen.style.display = "none";
      productElementclose.style.display = "block";
      promotionsElementopen.style.display = "block";
      promotionsElementclose.style.display = "none";
      giftElementopen.style.display = "none";
      giftElementclose.style.display = "block";

      child_anchor_ele[0].style.color = "";
      child_anchor_ele[1].style.color = "";
      child_anchor_ele[2].style.color = "#F00";
      child_anchor_ele[3].style.color = "";
      child_anchor_ele[4].style.color = "";
    });
  }

  if (fifthChild) {
    fifthChild.addEventListener("click", function () {
      collectionElement.style.display = "none";
      productElement.style.display = "none";
      giftElement.style.display = "block";
      promotionsElement.style.display = "none";
      pccElement.style.display = "none";
      promotionsElement.style.top = "55px";

      collectionElementopen.style.display = "none";
      collectionElementoclose.style.display = "block";
      productElementopen.style.display = "none";
      productElementclose.style.display = "block";
      promotionsElementopen.style.display = "none";
      promotionsElementclose.style.display = "block";
      giftElementopen.style.display = "block";
      giftElementclose.style.display = "none";

      child_anchor_ele[0].style.color = "";
      child_anchor_ele[1].style.color = "";
      child_anchor_ele[2].style.color = "";
      child_anchor_ele[3].style.color = "#F00";
      child_anchor_ele[4].style.color = "";
    });
  }

  if (seventhChild) {
    seventhChild.addEventListener("click", function () {
      collectionElement.style.display = "none";
      productElement.style.display = "none";
      giftElement.style.display = "none";
      promotionsElement.style.display = "none";
      pccElement.style.display = "block";

      collectionElementopen.style.display = "none";
      collectionElementoclose.style.display = "block";
      productElementopen.style.display = "none";
      productElementclose.style.display = "block";
      promotionsElementopen.style.display = "none";
      promotionsElementclose.style.display = "block";
      giftElementopen.style.display = "none";
      giftElementclose.style.display = "block";

      child_anchor_ele[0].style.color = "";
      child_anchor_ele[1].style.color = "";
      child_anchor_ele[2].style.color = "";
      child_anchor_ele[3].style.color = "";
      child_anchor_ele[4].style.color = "#F00";
    });
  }
});

window.onload = diamond1();
function clearActive12() {
  const tabs12 = document.querySelectorAll(".tablinks1");
  tabs12.forEach((tab22) => {
    tab22.classList.remove("pcc-activeR");
  });
}
function diamond1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.diamond")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "block";
   document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function showOnline1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.online1")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}

function showBridal1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.bridal1")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function qwertfaq() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.earing1223")
    .classList.add("pcc-activeR");
  document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}

function showLites1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.pendant")
    .classList.add("pcc-activeR");
   document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}

function showMugdhaa1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.mugdha")
    .classList.add("pcc-activeR");
   document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}

function showEterknight1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.earring")
    .classList.add("pcc-activeR");
   document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function qwertqqft4() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.jewellery1142")
    .classList.add("pcc-activeR");
   document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "block";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function qwertqqft4552() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.mangalsutra1142")
    .classList.add("pcc-activeR");
   document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "block";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function showLittle1() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.coin")
    .classList.add("pcc-activeR");
   document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "none";
}
function showSilver() {
  clearActive12();
  document
    .querySelector(".tablinks1.for-mobile1.pro_item.silver")
    .classList.add("pcc-activeR");
   document.getElementById("HeaderMenu-collections-diamond1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-online1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-earring1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-eterknight1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-chain223431").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-mangalsutra223431"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little1").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-silver").style.display =
    "block";
}
function qwertD3() {
  diamond1();
}
function qwert() {
  showOnline1();
}
function qwert1() {
  showBridal1();
}
function qwert2() {
  showLites1();
}
function qwert3() {
  showMugdhaa1();
}

function qwert4() {
  showEterknight1();
}
function qwert5() {
  showLittle1();
}
function qwert6() {
  showSilver();
}

function clearActive1() {
  const tabs = document.querySelectorAll(".mtablinks");
  tabs.forEach((tab) => {
    tab.classList.remove("pcc-active-m");
  });
}
function showOnline_mobcol() {
  clearActive1();
  document.querySelector(".online-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}

function showBridal_mobcol() {
  clearActive1();
  document.querySelector(".bridal-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}

function showLites_mobcol() {
  clearActive1();
  document.querySelector(".lites-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}

function showMugdhaa_mobcol() {
  clearActive1();
  document.querySelector(".mugdhaa-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "block";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}

function showEterknight_mobcol() {
  clearActive1();
  document.querySelector(".eter-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "block";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}
function showLittle_mobcol() {
  clearActive1();
  document.querySelector(".little-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}
function showRihi_mobcol() {
  clearActive1();
  document.querySelector(".rihis-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "block";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "none";
}
function showGcoin_mobcol() {
  clearActive1();
  document.querySelector(".gcb-mobile").classList.add("pcc-active-m");
  document.getElementById("HeaderMenu-collections-online-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-bridal-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-lites-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-mugdhaa-mcol").style.display =
    "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol"
  ).style.display = "none";
  document.getElementById("HeaderMenu-collections-little-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-rihi-mcol").style.display =
    "none";
  document.getElementById("HeaderMenu-collections-gcoin-mcol").style.display =
    "block";
}

function gold_color_effect1_mcol() {
  showOnline_mobcol();
}

function gold_color_effect2_mcol() {
  showBridal_mobcol();
}

function gold_color_effect3_mcol() {
  showLites_mobcol();
}

function gold_color_effect4_mcol() {
  showMugdhaa_mobcol();
}

function gold_color_effect5_mcol() {
  showEterknight_mobcol();
}
function gold_color_effect6_mcol() {
  showLittle_mobcol();
}
function gold_color_effect7_mcol() {
  showRihi_mobcol();
}
function gold_color_effect8_mcol() {
  showGcoin_mobcol();
}

window.onload = showOnline_mobcol();

function clearActive23() {
  const tabs1 = document.querySelectorAll(".tablinks-guidemob");
  tabs1.forEach((tab2) => {
    tab2.classList.remove("pcc-active-mkt");
  });
}

function showOnline_mobcol_gift() {
  clearActive23();
  document
    .querySelector(".online-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
}

function showBridal_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".bridal-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
}

function showLites_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".lites-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
}

function showMugdhaa_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".mugdhaa-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
}

function showEterknight_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".eter-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
}
function showLittle_mobcol_gif() {
  clearActive23();
  document
    .querySelector(".little-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "block";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "none";
}
function showLittle_mobcol_gif12() {
  clearActive23();
  document
    .querySelector(".rihis-mobile-guidemob")
    .classList.add("pcc-active-mkt");
  document.getElementById(
    "HeaderMenu-collections-online-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-bridal-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-lites-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-mugdhaa-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-eterknight-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-little-mcol-gif"
  ).style.display = "none";
  document.getElementById(
    "HeaderMenu-collections-rihi-mcol-gif"
  ).style.display = "block";
}

function gold_color_effect1_mcol_gif() {
  showOnline_mobcol_gift();
}

function gold_color_effect2_mcol_gif() {
  showBridal_mobcol_gif();
}

function gold_color_effect3_mcol_gif() {
  showLites_mobcol_gif();
}

function gold_color_effect4_mcol_gif() {
  showMugdhaa_mobcol_gif();
}

function gold_color_effect5_mcol_gif() {
  showEterknight_mobcol_gif();
}
function gold_color_effect6_mcol_gif() {
  showLittle_mobcol_gif();
}
function gold_color_effect7_mcol_gif() {
  showLittle_mobcol_gif12();
}


window.onload = showOnline_mobcol_gift();

document.querySelectorAll(".hover_store_cs").forEach((item) => {
  item.addEventListener("mouseenter", function () {
    
    document.querySelectorAll(".hover_store_cs").forEach((el) => {
      el.style.color = ""; 
    });
    
    this.style.color = "red";
  });
});

document.querySelectorAll(".hover_store_cs").forEach((item) => {
  item.addEventListener("click", function () {
    document.querySelectorAll(".hover_store_cs").forEach((el) => {
      el.style.color = ""; 
    });
    this.style.color = "red";

    document.querySelectorAll(".arrow_mob1_open")[0].style.color = "black";
    document.getElementById("arrow_mob2_open").style.color = "black";
    document.getElementById("arrow_mob3_open").style.color = "black";
    document.getElementById("arrow_mob4_open").style.color = "black";

    document.querySelectorAll(".element_op_clo").forEach((el) => {
      el.style.color = ""; 
    });
  });
});
function clearActive1212() {
  const tabs123 = document.querySelectorAll(".tablinks12");
  tabs123.forEach((tab221) => {
    tab221.classList.remove("pcc-active-mkt");
  });
}
function gold_color_effect_pramotion1() {
  clearActive1212();
  document
    .querySelector(".tablinks12.for-mobile12.online-mobile12")
    .classList.add("pcc-active-mkt");
  let pramotion1 = document.getElementById(
    "HeaderMenu-collections-online-pramotion_container1"
  );
  let pramotion2 = document.getElementById(
    "HeaderMenu-collections-bridal-pramotion_container2"
  );
  pramotion1.style.display = "block";
  // pramotion2.style.display = "none";
}
function gold_color_effect_pramotion2() {
  clearActive1212();
  document
    .querySelector(".tablinks12.for-mobile12.bridal-mobile12")
    .classList.add("pcc-active-mkt");
  let pramotion1 = document.getElementById(
    "HeaderMenu-collections-online-pramotion_container1"
  );
  let pramotion2 = document.getElementById(
    "HeaderMenu-collections-bridal-pramotion_container2"
  );
  pramotion1.style.display = "none";
  pramotion2.style.display = "block";
}
window.onload = gold_color_effect_pramotion1();

function showDiamondStyle(category, event) {
    const hideStyleBoxCategories = ['nosepins', 'necklaces', 'bracelets', 'kids', 'chain'];
    
    // Handle hover functionality
    if (event && event.type === 'mouseover') {
        // Remove active class from all category links
        const allCategoryLinks = document.querySelectorAll('.top_ten_top_outer_inner_block1 a, .top_ten_top_outer_inner_block2 a');
        allCategoryLinks.forEach(link => {
            link.classList.remove('active');
        });
        
        // Hide all style groups
        const styleGroups = document.querySelectorAll('.diamond-style-group');
        styleGroups.forEach(group => {
            group.style.display = 'none';
        });
        
        // Show the selected style group if not in hidden categories
        if (!hideStyleBoxCategories.includes(category)) {
            const selectedGroup = document.getElementById(`diamond-${category}-styles`);
            if (selectedGroup) {
                selectedGroup.style.display = 'inline-flex';
            }
        }
        
        document.querySelectorAll('.diamond_top_ten_inner_block1, .diamond_top_ten_inner_block2').forEach(b => b.style.display = 'none');
        const metalsBlock = document.querySelector(`.diamond_top_ten_inner_block1[data-category="${category}"]`);
        const genderBlock = document.querySelector(`.diamond_top_ten_inner_block2[data-category="${category}"]`);
        if (metalsBlock) metalsBlock.style.display = 'block';
        if (genderBlock) genderBlock.style.display = 'block';
        
        // Handle the style box visibility
        const topOuterBox = document.querySelector('.top_ten_top_outer_top_box.diamond_shop_by_style_top_box');
        const outerTopBlock = document.querySelector('.top_ten_outer_top_block.diamond_shop_by_style_box');
        
        if (hideStyleBoxCategories.includes(category)) {
            if (topOuterBox) topOuterBox.style.display = 'none';
            if (outerTopBlock) outerTopBlock.style.display = 'none';
        } else {
            if (topOuterBox) topOuterBox.style.display = 'block';
            if (outerTopBlock) outerTopBlock.style.display = 'block';
        }
        
        return false;
    }
    
    // Handle click functionality
    if (event && event.type === 'click') {
        // For # links, prevent default and just show the styles
        if (event.currentTarget.getAttribute('href') === '#') {
            event.preventDefault();
            
            // Show the styles (same as hover but keep active class)
            if (!hideStyleBoxCategories.includes(category)) {
                const selectedGroup = document.getElementById(`diamond-${category}-styles`);
                if (selectedGroup) {
                    document.querySelectorAll('.diamond-style-group').forEach(g => g.style.display = 'none');
                    selectedGroup.style.display = 'inline-flex';
                }
            }
            
            // Always show metals and gender blocks
            document.querySelectorAll('.diamond_top_ten_inner_block1, .diamond_top_ten_inner_block2').forEach(b => b.style.display = 'none');
            const metalsBlock = document.querySelector(`.diamond_top_ten_inner_block1[data-category="${category}"]`);
            const genderBlock = document.querySelector(`.diamond_top_ten_inner_block2[data-category="${category}"]`);
            if (metalsBlock) metalsBlock.style.display = 'block';
            if (genderBlock) genderBlock.style.display = 'block';
            
            // Set active class
            document.querySelectorAll('[onclick*="showDiamondStyle"]').forEach(link => link.classList.remove('active'));
            event.currentTarget.classList.add('active');
            
            // Handle the style box visibility
            const topOuterBox = document.querySelector('.top_ten_top_outer_top_box.diamond_shop_by_style_top_box');
            const outerTopBlock = document.querySelector('.top_ten_outer_top_block.diamond_shop_by_style_box');
            
            if (hideStyleBoxCategories.includes(category)) {
                if (topOuterBox) topOuterBox.style.display = 'none';
                if (outerTopBlock) outerTopBlock.style.display = 'none';
            } else {
                if (topOuterBox) topOuterBox.style.display = 'block';
                if (outerTopBlock) outerTopBlock.style.display = 'block';
            }
            
            return false;
        }
        // For real links, let them navigate normally
    }
    
    return false;
}
// Initialize with rings category active on load
document.addEventListener('DOMContentLoaded', function() {
    // Add mouseover event listeners to all category links
    document.querySelectorAll('[onclick^="showDiamondStyle"]').forEach(element => {
        const onclickContent = element.getAttribute('onclick');
        const categoryMatch = onclickContent.match(/showDiamondStyle\('([^']+)'/);
        if (categoryMatch && categoryMatch[1]) {
            const category = categoryMatch[1];
            
            element.addEventListener('mouseover', function(event) {
                showDiamondStyle(category, event);
            });
            
            // Update onclick to pass the event
            element.setAttribute('onclick', `showDiamondStyle('${category}', event)`);
        }
    });
    
    // Show rings by default
    const event = new Event('mouseover');
    showDiamondStyle('ring', event);
});

